import { appendClassName, Grid, GridSize } from '@gcl/react-core';
import * as React from 'react';
import { IGeneralInfoItem } from './generalInfoTable.models';
import './GeneralInfoTable.scss';

interface IGeneralInfoTableProps {
  items: IGeneralInfoItem[];
  className?: string;
  titleWidth?: GridSize;
}

export const GeneralInfoTable: React.FunctionComponent<IGeneralInfoTableProps> = ({
  items,
  className,
  titleWidth = 2,
}) => {
  const infoRow = (title: React.ReactNode | string, child: React.ReactNode | string, index: number) => {
    return (
      <Grid container key={`info-row-${index}`} className="gcl-gems-general-info-table-row" flexWrap="nowrap">
        <Grid item sm={12} md={titleWidth} flex="1 1 auto" className="gcl-gems-general-info-table-row-title">
          <span>{title}</span>
        </Grid>
        <Grid item flex="0 0 10px" />
        <Grid item sm={12} md={12 - (titleWidth as number)} flex="1 1 auto">
          <span>{child}</span>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container className={appendClassName('gcl-gems-general-info-table', className)}>
      {items.map((item, index) => infoRow(item.title, item.content, index))}
    </Grid>
  );
};
